export const CORES_DISTRIBUICAO_PRODUTOS = {
	estoque: "bg-amber-100",
	vendas: "bg-sky-300",
	necessidadeCompra: "bg-slate-300/20",
} as const;

export type DATE_PRESETS_TYPE = (typeof DATE_PRESETS)[number]["value"];
export const DATE_PRESETS = [
	{ value: "today", label: "Hoje" },
	{ value: "last7days", label: "Últimos 7 dias" },
	{ value: "last15days", label: "Últimos 15 dias" },
	{ value: "yesterday", label: "Ontem" },
	{ value: "thisWeek", label: "Essa semana" },
	{ value: "thisMonth", label: "Esse mês" },
	{ value: "lastMonth", label: "Mês passado" },
	{ value: "thisYear", label: "Esse ano" },
	{ value: "lastYear", label: "Ano passado" },
	{ value: "thisMonthUntilNow", label: "Mês até agora" },
] as const;

export const SINGLE_SELECT_OPERATORS = ["<", ">", "<=", ">=", "="] as const;
export const TEXT_SELECT_OPERATORS = ["eq", "ne", "gt", "gte", "lt", "lte"] as const;

export const ADVANCED_TEXT_OPERATORS = [...TEXT_SELECT_OPERATORS, "ilike", "startswith", "endswith"] as const;
export type AdvancedTextOperator = (typeof ADVANCED_TEXT_OPERATORS)[number];

export const ADVANCED_TEXT_OPERATOR_LABELS: Record<AdvancedTextOperator, string> = {
	eq: "Igual",
	ne: "Diferente",
	gt: "Maior que",
	gte: "Maior ou igual",
	lt: "Menor que",
	lte: "Menor ou igual",
	ilike: "Contém",
	startswith: "Começa com",
	endswith: "Termina com",
};

export const DEFAULT_LOADING_MESSAGES = [
	"⏳ Carregando...",
	"⌛ Só um instante...",
	"🛠️ Estamos preparando tudo para você...",
	"🚀 Quase lá...",
	"🔎 Buscando informações...",
	"🔄 Atualizando dados...",
	"⚙️ Processando sua solicitação...",
	"🎛️ Aplicando configurações...",
	"🌐 Sincronizando com o servidor...",
	"✅ Validando informações...",
	"🗂️ Organizando os dados...",
	"✨ Finalizando os ajustes...",
	"🖥️ Montando a tela para você...",
	"📦 Carregando detalhes adicionais...",
	"⏱️ Isso pode levar alguns segundos...",
	"📊 Dependendo do volume de dados, pode demorar um pouco. Aguarde.",
	"🧩 Estamos deixando tudo pronto para continuar...",
	"📥 Carregando recursos necessários...",
	"⚡ Aguarde… estamos otimizando a operação.",
	"👀 Preparando uma visualização mais completa...",
	"🔐 Verificando permissões e acessos...",
	"🧪 Conferindo consistência dos dados...",
	"🎚️ Carregando preferências e configurações...",
] as const;
